var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "600"
    }
  }, [_c('console-title', [_vm.$route.params._viewer ? _c('span', [_vm._v("관리자 상세")]) : _c('span', [_vm._v("관리자 생성")])]), _c('console-body', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "아이디",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.username,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "username", $$v);
      },
      expression: "viewer.username"
    }
  }), _c('v-password-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "비밀번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.password,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "password", $$v);
      },
      expression: "viewer.password"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "담당자(이름)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "name", $$v);
      },
      expression: "viewer.name"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "담당자(연락처)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "phone", $$v);
      },
      expression: "viewer.phone"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "담당자(이메일)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.email,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "email", $$v);
      },
      expression: "viewer.email"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "postcode", $$v);
      },
      expression: "viewer.postcode"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "기본주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "address1", $$v);
      },
      expression: "viewer.address1"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "상세주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "address2", $$v);
      },
      expression: "viewer.address2"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "ci",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.viewer.ci,
      callback: function callback($$v) {
        _vm.$set(_vm.viewer, "ci", $$v);
      },
      expression: "viewer.ci"
    }
  })], 1), _c('v-card-actions')], 1)], 1), _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }